module.exports = __webpack_public_path__ + "img/logoseebitajuba.92841a72.png";